import { render, staticRenderFns } from "./specialDetails.vue?vue&type=template&id=86876ffa&scoped=true"
import script from "./specialDetails.vue?vue&type=script&lang=js"
export * from "./specialDetails.vue?vue&type=script&lang=js"
import style0 from "./specialDetails.vue?vue&type=style&index=0&id=86876ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86876ffa",
  null
  
)

export default component.exports